import "@do/ui/styles/globals.css";
import "@do/ui-chat-v2/style.css";
import "@do/ui-chat-v2/default-theme.css";
import "../src/ui/global.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useEffect, useState } from "react";
import parser from "ua-parser-js";

const MyApp = ({ Component, pageProps }: AppProps) => {
  // One client per app instance, so the cache is never shared between server-side requests.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          // A chat must not refetch when its browser tab gains or loses the focus.
          queries: { retry: 3, refetchOnWindowFocus: false },
        },
      })
  );
  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = parser(navigator.userAgent);
      window.isAndroid = userAgent?.os?.name === "Android";
      window.isIos = userAgent?.os?.name === "iOS";
    }
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>
      <Component {...pageProps} />
    </QueryClientProvider>
  );
};

export default MyApp;
